export const reminderFrequencies = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
];

export const weekDays = [
  { value: 0, label: "Sunday" },
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
];

export const monthDays = Array.from({ length: 31 }, (_, index) => ({
  value: index + 1,
  label: `${index + 1}`,
}));

export const defaultReminderSettings = {
  enabled: false,
  frequency: "daily",
  preferred_time: "08:00",
  weekly_day: 1,
  monthly_day: 1,
};

export const frequencyLabel = (frequency) =>
  reminderFrequencies.find((item) => item.value === frequency)?.label || "Daily";

export const weekdayLabel = (day) => weekDays.find((item) => item.value === Number(day))?.label || "Monday";